import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsRoutingModule } from './settings-routing.module';
import { EmailTemplatesListComponent } from './email-templates-list/email-templates-list.component';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../shared/shared.module';
import { EmailTemplateEditorComponent } from './email-template-editor/email-template-editor.component';
import { SettingsShellComponent } from './settings-shell/settings-shell.component';
import { NgxUploaderModule } from '@angular-ex/uploader';
import { SettingsMainComponent } from './settings-main/settings-main.component';
import { SystemConfigurationComponent } from './system-configuration/system-configuration.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminNewComponent } from './admin-new/admin-new.component';
import { AdminEditComponent } from './admin-edit/admin-edit.component';
import { InfoPagesComponent } from './info-pages/info-pages.component';
import { InfoPagesEditComponent } from './info-pages-edit/info-pages-edit.component';
import { EmailSmsTemplatesListComponent } from './email-sms-templates-list/email-sms-templates-list.component';
import { EmailTabTemplatesListComponent } from './email-tab-templates-list/email-tab-templates-list.component';
import { SmsTabTemplatesListComponent } from './sms-tab-templates-list/sms-tab-templates-list.component';
import { TemplateDisplayComponent } from './template-display/template-display.component';
import { AdsManagePageComponent } from './ads-manage-page/ads-manage-page.component';
import { AdsEditComponent } from './ads-edit/ads-edit.component';
import { AdsTabListComponent } from './ads-tab-list/ads-tab-list.component';
import { AdsTabComponent } from './ads-tab/ads-tab.component';
import { AdsEditTabComponent } from './ads-edit-tab/ads-edit-tab.component';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    SettingsRoutingModule,
    TableModule,
    SharedModule,
    NgxUploaderModule,
    DatePicker,
  ],
  declarations: [
    TemplateDisplayComponent,
    EmailTabTemplatesListComponent,
    SmsTabTemplatesListComponent,
    EmailSmsTemplatesListComponent,
    EmailTemplatesListComponent,
    EmailTemplateEditorComponent,
    SettingsShellComponent,
    SettingsMainComponent,
    SystemConfigurationComponent,
    AdminUsersComponent,
    AdminNewComponent,
    AdminEditComponent,
    InfoPagesComponent,
    InfoPagesEditComponent,
    AdsManagePageComponent,
    AdsEditComponent,
    AdsTabListComponent,
    AdsTabComponent,
    AdsEditTabComponent,
  ],
})
export class SettingsModule {}
